import React from "react";
import moment from "moment";
import ReferencesSingleSelect from "./referencesSingleSelect";

class EmploymentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: props.initialState ? props.initialState.company : "",
      positionHeld: props.initialState ? props.initialState.positionHeld : "",
      employedFrom: props.initialState ? props.initialState.employedFrom : "",
      employedTo: props.initialState ? props.initialState.employedTo : "",
      workAttitude: props.initialState
        ? props.initialState.workAttitude
        : undefined,
      workQuality: props.initialState
        ? props.initialState.workQuality
        : undefined,
      workAccuracyAndSpeed: props.initialState
        ? props.initialState.workAccuracyAndSpeed
        : undefined,
      flexibilityAndAdaptability: props.initialState
        ? props.initialState.flexibilityAndAdaptability
        : undefined,
      teamwork: props.initialState ? props.initialState.teamwork : undefined,
      attendance: props.initialState
        ? props.initialState.attendance
        : undefined,
      timeKeeping: props.initialState
        ? props.initialState.timeKeeping
        : undefined,
      additionalComment: props.initialState
        ? props.initialState.additionalComment
        : "",
      reemploy: props.initialState ? props.initialState.reemploy : undefined,
      reemployComment: props.initialState
        ? props.initialState.reemployComment
        : "",
      honestAndHighIntegrity: props.initialState
        ? props.initialState.honestAndHighIntegrity
        : undefined,
      honestAndHighIntegrityComment: props.initialState
        ? props.initialState.honestAndHighIntegrityComment
        : "",
      refereeName: props.initialState ? props.initialState.refereeName : "",
      refereePosition: props.initialState
        ? props.initialState.refereePosition
        : ""
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.sendReference = this.sendReference.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value
    });
  }

  sendReference(event) {
    event.preventDefault();
    const data = {
      reference: {
        ...this.state,
        referenceType: "employment",
        referenceDate: moment().format("DD/MM/YYYY"),
        uniqueLink: this.props.token
      }
    };
    this.props.saveReference(data);
  }

  TextInput(props) {
    return (
      <div className="form-group">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          type="text"
          className="form-control"
          id={props.id}
          name={props.id}
          value={props.value}
          onChange={this.handleInputChange}
          required={props.required}
        />
      </div>
    );
  }

  AssessmentTable() {
    return (
      <div className="pb-1">
        <div className="font-text-bold">
          We would also appreciate your assessment of the following
          characteristics of their work and personal performance:
        </div>
        <ReferencesSingleSelect
          description="Attitude to work"
          value={this.state.workAttitude}
          name="workAttitude"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Quality of work"
          value={this.state.workQuality}
          name="workQuality"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Accuracy and speed of work"
          value={this.state.workAccuracyAndSpeed}
          name="workAccuracyAndSpeed"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Flexibility and adaptability"
          value={this.state.flexibilityAndAdaptability}
          name="flexibilityAndAdaptability"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Teamwork"
          value={this.state.teamwork}
          name="teamwork"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Attendance"
          value={this.state.attendance}
          name="attendance"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Timekeeping"
          value={this.state.timeKeeping}
          name="timeKeeping"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
      </div>
    );
  }

  render() {
    return (
      <form onSubmit={this.sendReference}>
        {this.TextInput({
          id: "company",
          label: "Company*",
          value: this.state.company,
          required: true
        })}
        {this.TextInput({
          id: "positionHeld",
          label: "Position Held*",
          value: this.state.positionHeld,
          required: true
        })}
        {this.TextInput({
          id: "employedFrom",
          label: "Date Employed From*",
          value: this.state.employedFrom,
          required: true
        })}
        {this.TextInput({
          id: "employedTo",
          label: "Date Employed To*",
          value: this.state.employedTo,
          required: true
        })}

        {this.AssessmentTable()}

        <div className="form-group">
          <label htmlFor="additionalComment">Any additional comments</label>
          <textarea
            className="form-control"
            id="additionalComment"
            name="additionalComment"
            value={this.state.additionalComment}
            onChange={this.handleInputChange}
            rows={3}
            required={false}
          ></textarea>
        </div>

        <div className="form-group">
          <ReferencesSingleSelect
            description="Would you re-employ?"
            value={this.state.reemploy}
            name="reemploy"
            onSelect={this.handleInputChange}
            options={["Yes", "No"]}
          />
          <div>
            {this.state.reemploy === "No" &&
              this.TextInput({
                id: "reemployComment",
                label: "Please comment as to why",
                value: this.state.reemployComment,
                required: false
              })}
          </div>
        </div>

        <div className="form-group">
          <ReferencesSingleSelect
            description="To your knowledge, would you say that this person is honest and of high integrity?"
            value={this.state.honestAndHighIntegrity}
            name="honestAndHighIntegrity"
            onSelect={this.handleInputChange}
            options={["Yes", "No"]}
          />
          <div>
            {this.state.honestAndHighIntegrity === "No" &&
              this.TextInput({
                id: "honestAndHighIntegrityComment",
                label: "Please comment as to why",
                value: this.state.honestAndHighIntegrityComment,
                required: false
              })}
          </div>
        </div>

        {this.TextInput({
          id: "refereeName",
          label: "Name of Referee*",
          value: this.state.refereeName,
          required: true
        })}

        {this.TextInput({
          id: "refereePosition",
          label: "Position of Referee*",
          value: this.state.refereePosition,
          required: true
        })}
        <div className="text-center">
          <button className="btn btn-primary" type="submit">
            Submit Reference
          </button>
        </div>
      </form>
    );
  }
}

export default EmploymentForm;
